let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8DRnL")).then(() => parcelRequire('9uVYs'));